import { render } from "./SubNetworksOtherSettingsForm.vue?vue&type=template&id=72ff5dde"
import script from "./SubNetworksOtherSettingsForm.vue?vue&type=script&lang=js"
export * from "./SubNetworksOtherSettingsForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__